/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Form, Input, Button, Select, List } from "antd";
import {
  updateCollaboration,
  getCollaboration,
} from "../../features/collaboration/collaborationSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditCollaboration = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [options, setOptions] = React.useState([]);
  const [currentOptions, setCurrentOptions] = React.useState([]);
  const [featureInput, setOptionInput] = React.useState("");
  const { isError, updating, message, isUpdateSuccess, collaboration } =
    useSelector((state) => state.collaboration);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values, options: currentOptions };
    dispatch(updateCollaboration({ id, data }));
  };

  const addOption = () => {
    if (featureInput) {
      setOptions([...options, featureInput]);
      setOptionInput("");
      setCurrentOptions([...currentOptions, { value: featureInput }]);
    }
  };

  const removeOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
    const newCurrentOptions = currentOptions.filter((_, i) => i !== index);
    setCurrentOptions(newCurrentOptions);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addOption();
    }
  };

  useEffect(() => {
    loadCollaboration();
  }, []);

  useEffect(() => {
    if (collaboration) {
      form.setFieldsValue({
        title: collaboration.title,
        status: collaboration?.status?.toString(),
      });
      const opts = [];
      collaboration?.options?.forEach((option) => {
        opts.push(option?.value || '');
      });
      console.log(opts);
      setCurrentOptions(collaboration?.options || []);
      setOptions(opts || []);
    }
  }, [collaboration]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Setting is updated successfully",
      });
      navigate("/admin/collaboration");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadCollaboration = () => {
    dispatch(getCollaboration(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Find A Collab</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Options">
          <Input
            value={featureInput}
            onChange={(e) => setOptionInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter a feature and press Enter"
          />
          <Button
            onClick={addOption}
            type="primary"
            style={{ marginTop: "10px" }}
          >
            Add Option
          </Button>
          <List
            size="small"
            bordered
            dataSource={options}
            renderItem={(item, index) => (
              <List.Item>
                {item}
                <Button
                  type="link"
                  onClick={(e) => {
                    e.preventDefault();
                    removeOption(index);
                  }}
                >
                  Remove
                </Button>
              </List.Item>
            )}
            style={{ marginTop: "10px", padding: "10px" }}
          />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditCollaboration;
